<template>
  <b-form @submit.prevent="submit">
  <b-row>
    <b-col cols="12">
      <b-form-group :label="$t('DOCUMENT_TYPE')">
        <b-select v-model="document_type" :options="document_type_options" value-field="id" text-field="name"></b-select>
        <app-validation-description :show="$v.document_type.$dirty && $v.document_type.$invalid">
          {{$t('FIELD_MANDATORY')}}
        </app-validation-description>
      </b-form-group>
    </b-col>
    <b-col cols="12">
      <b-form-group :label="$t('NAME')">
        <b-form-input accept="image/jpeg, image/png, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document" v-model="document_name"></b-form-input>
        <app-validation-description :show="$v.document_name.$dirty && $v.document_name.$invalid">
          {{$t('FIELD_MANDATORY')}}
        </app-validation-description>
      </b-form-group>
    </b-col>
    <b-col cols="12">
      <b-form-group :label="$t('FILE')">

        <b-form-file accept="image/jpeg, image/png, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document" @change="validateFileAndUpdate($event)"></b-form-file>
        <app-validation-description :show="$v.file.$dirty && $v.file.$invalid">
          {{$t('FIELD_MANDATORY')}}
        </app-validation-description>
        <span class="only-allowed">{{$t('SUPPORTED_TYPES')}} .pdf, .doc, .docx, .jpg, .jpeg, .png</span>
      </b-form-group>
    </b-col>

  </b-row>

    <b-row class="mt-3">
      <b-col>
        <app-button-submit :loading="loading" ></app-button-submit>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
  import AppButtonSubmit from '@/components/app/AppSubmit'
  import {documentTypeList, uploadDocument} from "@/services/document";
  import {toast} from "@/shared/plugins/toastr";
  import {required} from "vuelidate/lib/validators";
  import AppValidationDescription from "@/components/app/form/AppValidationDescription";
  import {getErrorMessage} from '@/mixins/error/getErrorMessage'
    export default {
        name: "DocumentUploadForm",
        mixins:[getErrorMessage],
        data(){
          return{
            document_type:null,
            document_name:null,
            file:null,
            loading:false,
            document_type_options:[]

          }
        },
      validations:{
        document_name:{required},
        document_type:{required},
        file:{required}
      },
      computed:{
        userObject(){
            return this.$store.getters['user/getUser']
        },
        objectId(){
          return Number(this.$route.params.id)
        }
      },
      methods:{
          submit(){
            this.$v.$touch()
            if(this.$v.$invalid){
              toast({
                'title': this.$t('VALIDATION_FAILED'),
                'message': null,
                'type': 'error',
                'timeout': 6000
              })
              return
            }
            let formData = new FormData();
            formData.append("file", this.file);
            formData.append("document_name", this.document_name);
            formData.append("document_type", this.document_type);
            this.loading = true
            uploadDocument(this.document_type, this.objectId,formData).then(response =>{
              toast({
                'title': this.$t('NOTIFICATIONS.SAVE_SUCCESS.MESSAGE'),
                'message': null,
                'type': 'success',
                'timeout': 2000
              })
              this.$emit('successUpload',response.data)
            }, error => {
              toast({
                'title': this.$t('NOTIFICATIONS.SAVE_ERROR.MESSAGE'),
                'message': null,
                'type': 'error',
                'timeout': 2000
              })
            }).finally(()=>{
              this.loading = false
            })
          },
          getDocumentTypeList(){
            documentTypeList({economy:this.userObject.economy.id}).then(response => {
              this.document_type_options = response.data
            })
          },
        validateFileAndUpdate(event) {
          console.log(event.target.files, 1);
          console.log(event.target.file, 2);

          const fileName = event.target.value;
          const dot = fileName.lastIndexOf(".") + 1;
          const extFile = fileName.substr(dot, fileName.length).toLowerCase();
          if (extFile == "jpg" || extFile == "jpeg" || extFile == "png" || extFile == "pdf" || extFile == "doc" || extFile == "docx") {
              this.file = event.target.files ? event.target.files[0] : null;
          } else {
            toast({
              'title': this.$t('UNSUPPORTED_TYPE') +' "' + extFile +'"',
              'message': '',
              'type': 'error',
              'timeout': 2000
            })
            this.file = null;
            event.target.value = null;
          }
        }
      },
      components:{
        AppValidationDescription,
        AppButtonSubmit
      },
      created(){
        this.getDocumentTypeList()
      }
    }
</script>

<style scoped>
.only-allowed {
  color: #FAA41B;
  font-size: 13px;
  margin-left: 2px;
}
</style>
